import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  HostListener,
} from "@angular/core";
import { FormArray, FormControl } from "@angular/forms";
import { Subject } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "app-input-pill",
  templateUrl: "./input-pill.component.html",
  styleUrls: ["./input-pill.component.scss"],
})
export class InputPillComponent implements OnInit, OnDestroy {
  public newInput: FormControl;
  @Input() autocompleteOptions: string[] = [];
  @Input() maxElements;
  @Input() disabled = false;
  @Input() control: FormArray;
  @Input() validators;
  @Input() placeholder = "";
  @Input() tooltip;
  @Input() minLength = 0;
  @Input() translationLabel = "";
  @Input() label = "";
  public showOptions: boolean = false;
  public filteredOptions: string[] = [];
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.newInput = this?.validators?.length
      ? new FormControl("", this.validators)
      : new FormControl("");
    this.newInput.valueChanges
      .pipe(map((value) => this.filterOptions(value)))
      .subscribe((filtered) => (this.filteredOptions = filtered.sort()));
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  get controlValue() {
    return this.control?.value;
  }

  get shouldDisable() {
    const input = this.newInput.value.trim();
    if (
      !input ||
      !this.newInput.valid ||
      this.control.getRawValue().includes(input) ||
      (this.minLength && input.length < this.minLength) ||
      (this.maxElements &&
        this.maxElements <= this.control.getRawValue().length)
    ) {
      return true;
    }
  }

  onFocus() {
    this.filteredOptions = this.autocompleteOptions.filter(
      (option) => !this.control.getRawValue().includes(option)
    );
  }

  @HostListener("mouseout", ["$event"])
  onMouseOut(event: MouseEvent) {
    const target = event.relatedTarget as HTMLElement;
    const isInside = target && target.closest(".input-pill-wrapper");
    if (!isInside) {
      this.filteredOptions = [];
    }
  }

  filterOptions(value: string): string[] {
    if (!value) return [];
    const filterValue = value.toLowerCase();
    return this.autocompleteOptions.filter(
      (option) =>
        // option.toLowerCase().includes(filterValue) &&
        option.toLowerCase().startsWith(filterValue) &&
        !this.control.getRawValue().includes(option)
    );
  }

  selectOption(option) {
    if (
      !option ||
      this.control.getRawValue().includes(option) ||
      (this.maxElements &&
        this.maxElements <= this.control.getRawValue().length)
    ) {
      return;
    }

    this.control.push(new FormControl(option));
    this.newInput.setValue("");
  }

  removeElement(index: number) {
    this.control.removeAt(index);
  }

  addInput() {
    const input = this?.newInput.value.trim();
    if (
      !input ||
      !this.newInput.valid ||
      this.control.getRawValue().includes(input) ||
      (this.minLength && input.length < this.minLength) ||
      (this.maxElements &&
        this.maxElements <= this.control.getRawValue().length)
    ) {
      return;
    }
    this.control.push(new FormControl(input));
    this.newInput.setValue("");
  }
}
